<template>
	<div ref="scrollContainer" id="page-panel" >
    <resize-observer @notify="__resizeHanlder" />
		<div class="customer-top-nav no-print">
			<div class="title">
				<span>{{$t('reservation.reservations')}}</span>
			</div>
			<div class="controls">
				<el-radio-group v-model="modeModel" class="hidden-sm-and-down" size="small">
					<el-radio-button label="list" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-list" style="font-size:12px;"></i></el-radio-button>
					<el-radio-button label="tile" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-grid" style="font-size:12px;"></i></el-radio-button>
				</el-radio-group>
				 <el-button type="primary" @click="openReservationCreator" size="small"><i class="mdi mdi-plus-circle"><span style="padding-left:5px;">{{$t('common.New')}}</span></i> </el-button>
			<el-dropdown size="small">
					<el-button  size="small">
						<i class="mdi mdi-download"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="handleDownloadCSV('CSV_EXPORT', 'filtered')" :disabled="!$can('read', 'Customer')"> <span class="mdi mdi-download"> {{ $t('reservation.downloadAllFilteredReservations') }}</span></el-dropdown-item>
					</el-dropdown-menu>
			</el-dropdown>
			</div>
		</div>
    <el-row>
      <el-col :span="leftPanelSpan"  >
        <ReservationsList @select="select"></ReservationsList>
			</el-col>
      <el-col :span="rightPanelSpan" v-if="showRightPanel" style="padding-left:10px;">
        <ReservationView @close="closeSelectedReservation" @edit="editSelectedReservation"></ReservationView>
			</el-col>
    </el-row>
	<WatingDialog :visible="reportLoading"></WatingDialog>
    <ReservationEditor :visible="reservationCreatorVisible" :edit="reservationToEdit" @close="closeReservationCreator" @created="updateReservationList" @updated="updateSelectedReservation"></ReservationEditor>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ReservationEditor from '@/components/reservation/reservation-editor'
import ReservationsList from './components/reservations-list'
import ReservationView from './components/reservation-view'
import ReservationAPI from '@/services/API/reservation'
import WatingDialog from '@/components/waiting-dialog'

export default {
  data() {
    return {
		reportLoading: false,
      leftPanelSpan : 24,
      pageWidth : 0,
			pageHeight : 0,
      rightPanelSpan:0,
      showRightPanel:false,
      search : '',
      soDialogVisible : false,
			editSelectedSalesOrder : null,
      reservationCreatorVisible : null,
			reservationToEdit:null,
    };
  },components: {
    ReservationEditor,
		ReservationsList,
		ReservationView,
		WatingDialog,
  },
  watch : {

  },
	methods: {
		handleDownloadCSV(report, type) {
			this.reportLoading = true;
			return this.getQueryParams()
				.then((params) => {
					return ReservationAPI.downloadReservationExtraction(report, type, params)
						.then(() => {
							this.reportLoading = false;
						})
				})
		},
		select(index){
			this.selectReservation({index});
			if(this.pageWidth<1054){
        this.leftPanelSpan=0;
        this.rightPanelSpan = 24;
      }else{
        this.leftPanelSpan=12;
        this.rightPanelSpan=12;
      }
			this.showRightPanel=true;
		},
		closeSelectedReservation(){
			this.rightPanelSpan=0;
      this.leftPanelSpan=24;
      this.showRightPanel=false;
		},
    updateReservationList(){
			this.invalidateReservationList();
			this.fetchReservations();
    },
    openReservationCreator(){
      this.reservationCreatorVisible=true;
    },
		editSelectedReservation(){
			this.reservationToEdit=this.selectedReservation;
			this.openReservationCreator();
		},
    closeReservationCreator(){
      this.reservationCreatorVisible=false;
			this.reservationToEdit = null;
    },
		updateSelectedReservation(reservationUpdated){
				this.updateSelecteReservation(reservationUpdated);
		},
    close(){
			this.$router.go(-1);
		},
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
			this.setPageWidth();
		}, 700),
		...mapActions('reservations', [ 'fetchReservations','selectReservation','invalidateReservationList','setEditReservation','updateSelecteReservation','changeMode', 'getQueryParams']),
	},
	computed: {
		modeModel : {
			get(){ return this.mode},
			set(mode){this.closeSelectedReservation();this.changeMode(mode)}
		},
		...mapState('reservations', [ 'reservations','loading', 'selectedReservation','mode']),
	},
  mounted(){
    this.setPageWidth()
  },
	created(){
    this.invalidateReservationList();
		this.fetchReservations();

	}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:80px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:10px;
	}
}

.el-table tr, .el-table__row{
  background-color: #f3f7fa;
}


@media (max-width: 1024px) {
  img.inventory {
    margin-top:20px;
    height:175px;
  }
}
</style>
